import { render, staticRenderFns } from "./EvolucionRegion.vue?vue&type=template&id=06e59592&"
import script from "./EvolucionRegion.vue?vue&type=script&lang=js&"
export * from "./EvolucionRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports